var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.233,
    cy: 19.4502,
    r: 18.75,
    fill: "#FDFDFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8777 11.9337C30.0077 12.3125 29.0807 12.5635 28.1142 12.6854C29.1085 12.0962 29.8673 11.1703 30.2241 10.0543C29.2971 10.6029 28.2736 10.9904 27.1828 11.2066C26.3026 10.2763 25.048 9.7002 23.6794 9.7002C21.0241 9.7002 18.8865 11.8394 18.8865 14.4618C18.8865 14.8391 18.9186 15.2019 18.9976 15.5473C15.0103 15.3543 11.4821 13.4575 9.11188 10.5681C8.69809 11.2806 8.45537 12.0962 8.45537 12.9743C8.45537 14.6229 9.31074 16.0843 10.5857 16.9304C9.81519 16.9159 9.05925 16.6938 8.41882 16.3441C8.41882 16.3586 8.41882 16.3775 8.41882 16.3963C8.41882 18.7097 10.0813 20.6311 12.2614 21.0738C11.871 21.1797 11.4455 21.2305 11.0039 21.2305C10.6969 21.2305 10.3869 21.2131 10.0959 21.1492C10.7173 23.0344 12.4807 24.4204 14.5775 24.4654C12.9457 25.7323 10.8738 26.4957 8.63083 26.4957C8.23751 26.4957 7.86027 26.4783 7.48303 26.4304C9.60756 27.7902 12.1254 28.5667 14.8407 28.5667C23.6663 28.5667 28.4914 21.3103 28.4914 15.0205C28.4914 14.8101 28.4841 14.6069 28.4739 14.4052C29.4258 13.7347 30.2256 12.8973 30.8777 11.9337Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.8876146eae8fd420cc2b8344c54bd16b.svg";
export { ForwardRef as ReactComponent };